import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { isNotDefined } from '@sgme/fp';
import { v4 } from 'uuid';

import { userApi } from '@/api/user';
import { tabsAdapter } from '@/store/tabs/adapter';
import type { TabsState } from '@/store/tabs/types';
import { generateDefaultTilesTabName } from '@/store/tabs/utils';

export function onCurrentUserDataFetched(builder: ActionReducerMapBuilder<TabsState>) {
  builder.addMatcher(userApi.endpoints.currentUser.matchFulfilled, (state, action) => {
    const [defaultClient] = action.payload.clients ?? [];

    if (isNotDefined(defaultClient)) {
      // when there is no client associated to the user
      // this is fatal to the app,
      // it won't ever display the tabs anyway
      console.log('No default client, default tab creation skipped.');
      return;
    }

    state.defaultClientId = defaultClient.companyId;

    if (tabsAdapter.getSelectors().selectTotal(state.tabs) > 0) {
      return;
    }

    const tabId = v4();
    tabsAdapter.addOne(state.tabs, {
      id: tabId,
      tabType: 'tiles',
      clientId: defaultClient.companyId,
      tabName: generateDefaultTilesTabName([]),
      isShared: false,
    });
    state.activeTabId = tabId;
  });
}
